import Constants from '../../../common/constants';

const imageFolder = `${Constants.IMAGE_FOLDER}destandvastige/`;

const title = "Holy Road - De Standvastige";
const description = "De Palestijnse familie Sub Laban woont in de moslimwijk van de Oude Stad in Jeruzalem. Ooit woonden hier Joden. Daarom wordt hun huis onteigend.";
const featuredImage = `${imageFolder}destandvastige/omslag.jpg`;

export default [
    {
        type: "Meta",
        title: title,
        meta: [
            {"property": "og:title", "content": title},
            {"property": "og:url", "content": `${Constants.DOMAIN}${Constants.STORY_URL}destandvastige`},
            {"property": "description", "content": ""},
            {"property": "og:description", "content": description},
            {"property": "og:image", "content": featuredImage},
            {"property": "twitter:card", "content": `summary_large_image`},
            {"property": "twitter:title", "content": title},
            {"property": "twitter:description", "content": description},
            {"property": "twitter:image", "content": featuredImage},
        ]
    },
    {
        type: "Quote",
        quote: description,
    },
    {
        type: "Iframe",
        hideSpacer: true,
        url: "https://player.vimeo.com/video/216162913"
    },
    {
        type: "Paragraph",
        text: "In de slaapkamermuur is de stopverf nog goed zichtbaar. De Palestijnse Nora Sub Laban wijst naar zeven plekken op de muur: hier boorden haar buren telkens een gat. 'Om te kijken wat erachter zat, zeiden ze. Maar waarom deden ze het dan zeven keer?' De buren van Nora Sub Laban, in de moslimwijk van de Oude Stad in bezet Oost-Jeruzalem, zijn Joodse kolonisten. Vroeger was de kamer naast de slaapkamer ook van de familie Sub Laban, maar stapje voor stapje wordt het huis verder door de buren overgenomen."
    },
    {
        type: "Paragraph",
        text: "Absurd? Niet in Jeruzalem. Nora Sub Laban kan naar de politie stappen, maar die zal niets voor haar doen. Zelfs de Israëlische rechter geeft de Joodse buren gelijk, en soldaten kijken toe als er weer eens een ruimte wordt overgenomen. Een juridische strijd van enkele decennia levert de familie vooralsnog niets op. Dit is het gevolg van een Israëlische wet die bepaalt dat Joden rechtmatig alle huizen van Palestijnen kunnen claimen waarin ooit een Jood heeft gewoond. In het geval van de familie Sub Laban gaat het om een Joodse huurder in de jaren dertig van de twintigste eeuw."
    },
    {
        type: "Paragraph",
        text: "Tijdens de Arabisch-Israëlische Oorlog van 1948 werd de Oude Stad van Jeruzalem veroverd door Jordanië, en sindsdien is het huis in familiebezit. Nora en haar man mogen er nog blijven wonen, heeft de rechter geoordeeld – maar na deze generatie is het afgelopen. Dan moeten ze het afstaan aan de kolonisten. In diezelfde oorlog zijn er ook honderden Palestijnse huizen in het tegenwoordige West-Jeruzalem in Joodse handen gekomen. Een paar honderd meter van het huis van Nora Sub Laban, even buiten de Oude Stad in de wijk Musrara, staan van oorsprong Arabische mansions waar nu Joden wonen. Maar andersom geldt de wet niet. Geen Palestijn kan een huis terugeisen dat ooit door zijn familie bewoond is geweest. De Israëlische wet is expliciet gericht op het verjoodsen van zowel Israël als de gebieden onder zijn controle, zoals bezet Oost-Jeruzalem."
    }
]


// WEBPACK FOOTER //
// ./src/data/nl/stories/story4.js